import React from 'react';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';


function Notifications() {

    return (
        <>
            <div className="right-section">
                <div className="customer-top-left">
                    <ul>
                        <li><a href="#" className="active">All</a></li>
                        <li><a href="#" className="">Active</a></li>
                        <li><a href="#" className="">Blocked</a></li>
                    </ul>
                </div>
                <div className="notification-dropdown notification-page">
                    <div className="notification-list">
                        <div className="notification-item active">
                            <div className="notification-icon">
                                <img src={window.getPublicUrl('/images/reports.svg')} alt="Notification" />
                            </div>
                            <div className="notification-content">
                                <p className="notification-text">Report Received</p>
                                <p className="notification-time">John Deo & Alisha Roy are now matched</p>
                                <p className='noti-time-adjust'>12 min ago</p>
                            </div>
                            <div className=''>
                                <img src={window.getPublicUrl('/images/export.svg')} alt="Notification" />
                            </div>
                        </div>
                        <div className="notification-item">
                            <div className="notification-icon">
                                <img src={window.getPublicUrl('/images/create-math.svg')} alt="Notification" />
                            </div>
                            <div className="notification-content">
                                <p className="notification-text">Match Created</p>
                                <p className="notification-time">John Deo & Alisha Roy are now matched</p>
                                <p className='noti-time-adjust'>12 min ago</p>
                            </div>
                            <div className=''>
                                <img src={window.getPublicUrl('/images/export.svg')} alt="Notification" />
                            </div>
                        </div>
                        <div className="notification-item">
                            <div className="notification-icon">
                                <img src={window.getPublicUrl('/images/video-call.svg')} alt="Notification" />
                            </div>
                            <div className="notification-content">
                                <p className="notification-text">Video Call Scheduled</p>
                                <p className="notification-time">Emily scheduled a call with Tom for 2 July, 5 PM</p>
                                <p className='noti-time-adjust'>25 min ago</p>
                            </div>
                            <div className=''>
                                <img src={window.getPublicUrl('/images/export.svg')} alt="Notification" />
                            </div>
                        </div>
                        <div className="notification-item">
                            <div className="notification-icon">
                                <img src={window.getPublicUrl('/images/plan-upgrade.svg')} alt="Notification" />
                            </div>
                            <div className="notification-content">
                                <p className="notification-text">Plan Upgrade</p>
                                <p className="notification-time">Olivia upgraded to Premium Plus</p>
                                <p className='noti-time-adjust'>5 min ago</p>
                            </div>
                            <div className=''>
                                <img src={window.getPublicUrl('/images/export.svg')} alt="Notification" />
                            </div>
                        </div>
                        <div className="notification-item">
                            <div className="notification-icon">
                                <img src={window.getPublicUrl('/images/cv-icon.svg')} alt="Notification" />
                            </div>
                            <div className="notification-content">
                                <p className="notification-text">Resume Limit Reached</p>
                                <p className="notification-time">Free user Jack tried to send 6th resume</p>
                                <p className='noti-time-adjust'>Today, 9:00 AM</p>
                            </div>
                            <div className=''>
                                <img src={window.getPublicUrl('/images/export.svg')} alt="Notification" />
                            </div>
                        </div>

                    </div>

                </div>

            </div>

        </>
    );
}

export default Notifications;